import { Card, Flex, Segmented, Tooltip, Typography } from "antd";
import { useMemo, useState } from "react";
import useCalibrationStatus from "../../hooks/useCalibrationStatus";
import VerifyHeatMap from "../../verifiers/verify_heat_map";

const { Text } = Typography;

export default function HeatMapWrapper({
  selectedDateRange,
  selectedPeriod,
  isLastRecordPending,
}) {
  const [normalizationMode, setNormalizationMode] = useState("store");
  const [zoneScope, setZoneScope] = useState("filtered");
  const [viewMode, setViewMode] = useState("3d");
  const [personScope, setPersonScope] = useState("cliente");

  const { hasCalibration, hasLayoutImage } = useCalibrationStatus();
  const hasMulticamera = hasCalibration || hasLayoutImage;

  const normalizationOptions = useMemo(
    () => [
      {
        label: "Máximo por Loja",
        value: "store",
      },
      {
        label: "Máximo por Câmera",
        value: "camera",
      },
    ],
    []
  );

  const zoneScopeOptions = useMemo(
    () => [
      {
        label: "Sem Filtro",
        value: "all",
      },
      {
        label: "Filtrar Zonas",
        value: "filtered",
      },
    ],
    []
  );

  const viewOptions = useMemo(
    () => [
      { label: "Câmeras", value: "3d" },
      {
        label: (
          <Tooltip
            title={
              !hasLayoutImage
                ? "Disponível apenas para lojas com calibração multicâmera"
                : null
            }>
            <span>{"Planta Baixa"}</span>
          </Tooltip>
        ),
        value: "2d",
        disabled: !hasLayoutImage,
      },
    ],
    [hasLayoutImage]
  );

  const personOptions = useMemo(
    () => [
      { label: "Todos", value: "todos" },
      {
        label: (
          <Tooltip
            title={
              !hasCalibration
                ? "Disponível apenas para lojas com abordagem multicâmera"
                : null
            }>
            <span>{"Clientes"}</span>
          </Tooltip>
        ),
        value: "cliente",
        disabled: !hasCalibration,
      },
      {
        label: (
          <Tooltip
            title={
              !hasCalibration
                ? "Disponível apenas para lojas com abordagem multicâmera"
                : null
            }>
            <span>{"Vendedores"}</span>
          </Tooltip>
        ),
        value: "vendedor",
        disabled: !hasCalibration,
      },
    ],
    [hasCalibration]
  );

  return (
    <Card
      title="Mapa de Calor"
      align="center"
      style={{
        width: "85%",
      }}
      styles={{
        header: {
          backgroundColor: "var(--ouran-card-header-bg)",
        },
      }}>
      <Flex
        gap={12}
        wrap
        align="center"
        justify={hasMulticamera ? "space-between" : "center"}
        style={{ marginBottom: 16 }}>
        {hasMulticamera && (
          <Flex gap={8} align="center" wrap>
            <Text strong style={{ color: "#4b5563" }}>
              {"Visualização:"}
            </Text>
            <Segmented
              options={viewOptions}
              value={viewMode}
              onChange={setViewMode}
            />
          </Flex>
        )}

        {hasMulticamera && (
          <Flex gap={8} align="center" wrap>
            <Text strong style={{ color: "#4b5563" }}>
              {"Pessoas:"}
            </Text>
            <Segmented
              options={personOptions}
              value={personScope}
              onChange={setPersonScope}
            />
          </Flex>
        )}

        <Flex gap={8} align="center" wrap>
          <Text strong style={{ color: "#4b5563" }}>
            {"Máximo:"}
          </Text>
          <Segmented
            options={normalizationOptions}
            value={normalizationMode}
            onChange={setNormalizationMode}
            disabled={viewMode === "2d"}
          />
        </Flex>

        <Flex gap={8} align="center" wrap>
          <Text strong style={{ color: "#4b5563" }}>
            {"Análise:"}
          </Text>
          <Tooltip
            title={
              viewMode === "2d"
                ? "Planta Baixa filtra apenas detecções por zona automaticamente"
                : null
            }>
            <Segmented
              options={zoneScopeOptions}
              value={zoneScope}
              onChange={setZoneScope}
              disabled={viewMode === "2d"}
            />
          </Tooltip>
        </Flex>
      </Flex>

      <VerifyHeatMap
        selectedDateRange={selectedDateRange}
        selectedPeriod={selectedPeriod}
        isLastRecordPending={isLastRecordPending}
        normalizationMode={normalizationMode}
        zoneScope={zoneScope}
        viewMode={viewMode}
        personScope={hasMulticamera ? personScope : "todos"}
      />
    </Card>
  );
}
